<template>
    <div>
      <!--认证办理-->
      <div class="logindiv" id="handleForm_auth">
        <div class="loginForm">
          <div style="width: 100%;height: 40px;background-color: #2d2d2d;margin: 0 auto;">
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: left;margin-left: 20px;">
              添加审核信息
            </span>
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: right;margin-right: 20px;">
              <a href="javascript:;" @click="closehandle">
                <i class="el-icon-close"></i>
              </a>
            </span>
          </div>
          <div style="width: 300px;margin: 0 auto;">
            <el-form :model="AddForm" :rules="rules" ref="AddForm" style="margin-top: 50px;">
              <el-form-item prop="reject_type">
                <el-radio v-model="AddForm.reject_type" label="2">同意</el-radio>
                &nbsp;
                <el-radio v-model="AddForm.reject_type" label="3">不同意</el-radio>
              </el-form-item>
              <el-form-item prop="reject_content">
                <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5}" v-model="AddForm.reject_content" placeholder="反馈内容"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :loading="loading" style="width: 300px;" @click="Addhandle">提交</el-button>
              </el-form-item>
            </el-form>
          </div>
          <br>
        </div>
      </div>
      <!--认证详情单-->
      <div class="Orderinfordiv" id="Aut_information_auth">
        <div class="OrderinforForm">
          <!--头部标签-->
          <div style="width: 100%;height: 40px;background-color: #2d2d2d;">
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: left;margin-left: 20px;">
              认证办理
            </span>
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: right;margin-right: 20px;">
              <a href="javascript:;" @click="close()">
                <i class="el-icon-close"></i>
              </a>
            </span>
          </div>
          <!--主体结构-->
          <div class="playlistbox_botton">
            <div style="margin: 0 auto;width: 750px;">
              <div class="h10"></div>
              <table width="100%" border="1" cellspacing='0' cellpadding='0'>
                <tr>
                  <td width="50%"><span style="font-size: 16px;font-weight: bold;">认证编号：{{data.id}}</span></td>
                  <td width="50%">认证结果：
                    <span style="color: #ff0000;" v-if="data.type==0&&data.reject_type==0">未认证</span>
                    <span style="color: #ff6700;" v-if="data.type==2&&data.reject_type==1">等待审核</span>
                    <span style="color: green;" v-if="data.type==3&&data.reject_type==2">认证成功</span>
                    <span style="color: #ff0000;" v-if="data.type==3&&data.reject_type==3">
                      认证失败
                      <span style="float: right;">
                        <el-button type="warning" size="mini" @click="errorPD()">失败原因</el-button>
                      </span>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td width="50%">认证商户(店铺)全称：{{data.shopname}}</td>
                  <td width="50%">认证商户性质：{{data.company_certificate_name}}</td>
                </tr>
                <tr>
                  <td width="50%">认证商户证件类型：{{data.company_name}}</td>
                  <td width="50%">认证商户证件号码：{{data.companyID}}</td>
                </tr>
                <tr>
                  <td width="50%">认证商户证件住所：{{data.shopabode}}</td>
                  <td width="50%">认证商户所属区域：{{data.address}}</td>
                </tr>
                <tr>
                  <td width="50%">认证商户通信地址：{{data.postaladdress}}</td>
                  <td width="50%">投资人或主管单位：{{data.investor}}</td>
                </tr>
                <tr>
                  <td width="50%">负责人姓名：{{data.peoplename}}</td>
                  <td width="50%">负责人证件类型：{{data.option3_name}}</td>
                </tr>
                <tr>
                  <td width="50%">负责人证件号码：{{data.peopleID}}</td>
                  <td width="50%">联系方式：{{data.phone}}</td>
                </tr>
                <tr>
                  <td width="50%">电子邮件地址：{{data.email}}</td>
                  <td width="50%">应急联系电话：{{data.urgentphone}}</td>
                </tr>
                <tr>
                  <td colspan="2">备注信息：{{data.content}}</td>
                </tr>
                <tr>
                  <td width="50%">认证证明：
                    <el-image
                      style="width: 100px;"
                      :src="data.company_img"
                      :preview-src-list="transformation_data(data.company_img)">
                    </el-image>
                  </td>
                  <td width="50%">负责人证明：
                    <el-image
                      style="width: 100px;"
                      :src="data.people_img"
                      :preview-src-list="transformation_data(data.people_img)">
                    </el-image>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">审批意见：{{data.reject_content}}</td>
                </tr>
              </table>
              <!--认证按钮-->
              <div style="margin-top: 10px;margin-bottom: 10px;float: right;">
                <el-button type="primary" @click="openhandle(data)" v-if="data.type=='2'">继续</el-button>
              </div>
            </div>
          </div>

        </div>
      </div>

      <el-tabs tab-position="left" style="height: 820px;">
        <!--等待审核-->
        <el-tab-pane label="等待审核">
          <div>
            <el-container>
              <el-header style="background-color:white;margin-top: 5px;height: 40px;">
                <el-form :inline="true" :model="formInline" class="demo-form-inline" size="mini">
                  <el-form-item label="认证编号">
                    <el-input v-model="formInline.id" placeholder="认证编号" class="elInput"></el-input>
                  </el-form-item>
                  <el-form-item label="申请人 / 负责人">
                    <el-input v-model="formInline.name" placeholder="申请人 / 负责人" class="elInput"></el-input>
                  </el-form-item>
                  <el-form-item label="起始日期">
                    <el-date-picker v-model="formInline.statetime" type="date" value-format="timestamp" placeholder="起始日期"></el-date-picker>
                  </el-form-item>
                  <el-form-item label="结束日期">
                    <el-date-picker v-model="formInline.endtime" type="date" value-format="timestamp" placeholder="结束日期"></el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" class="btn" @click="getData()"><i class="el-icon-search"></i>查询</el-button>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="danger" class="btn" @click="resetting()"><i class="el-icon-refresh"></i>重置</el-button>
                  </el-form-item>
                </el-form>
              </el-header>
              <el-main class="elMain">
                <el-table v-loading="loading" :data="tableData" height="100%" stripe border size="medium ">
                  <el-table-column align="center" label="申请人" prop="u_name" width="100"></el-table-column>
                  <el-table-column align="center" label="认证编号" prop="id" width="250"></el-table-column>
                  <el-table-column align="center" label="认证商户名称" prop="shopname" width="120"></el-table-column>
                  <el-table-column align="center" label="认证性质" prop="company_name" width="120"></el-table-column>
                  <el-table-column align="center" label="认证证件号" prop="companyID" width="200">
                    <template slot-scope="scope">
                      <span>
                        <a style="color: #439eff;" :href="'https://www.qcc.com/web/search?key='+scope.row.companyID" target="_blank">
                          {{scope.row.companyID}}
                        </a>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="负责人" prop="peoplename" width="100"></el-table-column>
                  <el-table-column align="center" label="负责人证件号" prop="peopleID" width="170"></el-table-column>
                  <el-table-column align="center" label="提交时间" prop="time" width="170">
                    <template slot-scope="scope">
                      <span>{{scope.row.time*1 | formatDate}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column fixed="right" label="操作">
                    <template slot-scope="scope">
                      <span>
                        <el-button size="small" type="primary" slot="reference" @click="openA(scope.row)">办理</el-button>
                      </span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-main>
              <el-footer>
                <div style="padding: 15px 0;text-align: right;">
                  <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="formInline.pageNum"
                    :page-sizes="pageSizes" :page-size="formInline.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
                  </el-pagination>
                </div>
              </el-footer>
            </el-container>
          </div>
        </el-tab-pane>
        <!--审核成功-->
        <el-tab-pane label="审核成功">
          <div>
            <el-container>
              <el-header style="background-color:white;margin-top: 5px;height: 40px;">
                <el-form :inline="true" :model="formInline1" class="demo-form-inline" size="mini">
                  <el-form-item label="认证编号">
                    <el-input v-model="formInline1.id" placeholder="认证编号" class="elInput"></el-input>
                  </el-form-item>
                  <el-form-item label="申请人 / 负责人">
                    <el-input v-model="formInline1.name" placeholder="申请人 / 负责人" class="elInput"></el-input>
                  </el-form-item>
                  <el-form-item label="起始日期">
                    <el-date-picker v-model="formInline1.statetime" type="date" value-format="timestamp" placeholder="起始日期"></el-date-picker>
                  </el-form-item>
                  <el-form-item label="结束日期">
                    <el-date-picker v-model="formInline1.endtime" type="date" value-format="timestamp" placeholder="结束日期"></el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" class="btn" @click="getData1()"><i class="el-icon-search"></i>查询</el-button>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="danger" class="btn" @click="resetting1()"><i class="el-icon-refresh"></i>重置</el-button>
                  </el-form-item>
                </el-form>
              </el-header>
              <el-main class="elMain">
                <el-table v-loading="loading" :data="tableData1" height="100%" stripe border size="medium ">
                  <el-table-column align="center" label="申请人" prop="u_name" width="100"></el-table-column>
                  <el-table-column align="center" label="认证编号" prop="id" width="250"></el-table-column>
                  <el-table-column align="center" label="认证商户名称" prop="shopname" width="120"></el-table-column>
                  <el-table-column align="center" label="认证性质" prop="company_name" width="120"></el-table-column>
                  <el-table-column align="center" label="认证证件号" prop="companyID" width="200">
                    <template slot-scope="scope">
                      <span>
                        <a style="color: #439eff;" :href="'https://www.qcc.com/web/search?key='+scope.row.companyID" target="_blank">
                          {{scope.row.companyID}}
                        </a>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="负责人" prop="peoplename" width="100"></el-table-column>
                  <el-table-column align="center" label="负责人证件号" prop="peopleID" width="170"></el-table-column>
                  <el-table-column align="center" label="提交时间" prop="time" width="170">
                    <template slot-scope="scope">
                      <span>{{scope.row.time*1 | formatDate}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column fixed="right" label="操作">
                    <template slot-scope="scope">
                      <span>
                        <el-button size="small" type="primary" @click="openA(scope.row)">查看</el-button>
                      </span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-main>
              <el-footer>
                <div style="padding: 15px 0;text-align: right;">
                  <el-pagination background @size-change="handleSizeChange1" @current-change="handleCurrentChange1" :current-page="formInline1.pageNum"
                    :page-sizes="pageSizes1" :page-size="formInline1.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal1">
                  </el-pagination>
                </div>
              </el-footer>
            </el-container>
          </div>
        </el-tab-pane>
        <!--审核失败-->
        <el-tab-pane label="审核失败">
          <div>
            <el-container>
              <el-header style="background-color:white;margin-top: 5px;height: 40px;">
                <el-form :inline="true" :model="formInline2" class="demo-form-inline" size="mini">
                  <el-form-item label="认证编号">
                    <el-input v-model="formInline2.id" placeholder="认证编号" class="elInput"></el-input>
                  </el-form-item>
                  <el-form-item label="申请人 / 负责人">
                    <el-input v-model="formInline2.name" placeholder="申请人 / 负责人" class="elInput"></el-input>
                  </el-form-item>
                  <el-form-item label="起始日期">
                    <el-date-picker v-model="formInline2.statetime" type="date" value-format="timestamp" placeholder="起始日期"></el-date-picker>
                  </el-form-item>
                  <el-form-item label="结束日期">
                    <el-date-picker v-model="formInline2.endtime" type="date" value-format="timestamp" placeholder="结束日期"></el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" class="btn" @click="getData2()"><i class="el-icon-search"></i>查询</el-button>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="danger" class="btn" @click="resetting2()"><i class="el-icon-refresh"></i>重置</el-button>
                  </el-form-item>
                </el-form>
              </el-header>
              <el-main class="elMain">
                <el-table v-loading="loading" :data="tableData2" height="100%" stripe border size="medium ">
                  <el-table-column align="center" label="申请人" prop="u_name" width="100"></el-table-column>
                  <el-table-column align="center" label="认证编号" prop="id" width="250"></el-table-column>
                  <el-table-column align="center" label="认证商户名称" prop="shopname" width="120"></el-table-column>
                  <el-table-column align="center" label="认证性质" prop="company_name" width="120"></el-table-column>
                  <el-table-column align="center" label="认证证件号" prop="companyID" width="200">
                    <template slot-scope="scope">
                      <span>
                        <a style="color: #439eff;" :href="'https://www.qcc.com/web/search?key='+scope.row.companyID" target="_blank">
                          {{scope.row.companyID}}
                        </a>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="负责人" prop="peoplename" width="100"></el-table-column>
                  <el-table-column align="center" label="负责人证件号" prop="peopleID" width="170"></el-table-column>
                  <el-table-column align="center" label="提交时间" prop="time" width="170">
                    <template slot-scope="scope">
                      <span>{{scope.row.time*1 | formatDate}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column fixed="right" label="操作">
                    <template slot-scope="scope">
                      <span>
                        <el-button size="small" type="primary" slot="reference" @click="openA(scope.row)">查看</el-button>
                      </span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-main>
              <el-footer>
                <div style="padding: 15px 0;text-align: right;">
                  <el-pagination background @size-change="handleSizeChange2" @current-change="handleCurrentChange2" :current-page="formInline2.pageNum"
                    :page-sizes="pageSizes2" :page-size="formInline2.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal1">
                  </el-pagination>
                </div>
              </el-footer>
            </el-container>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
</template>

<script>
  import {commonAPI} from '@/api/commonAPI'
  export default {
    data() {
      var reject_content = (rule, value, callback) => {
        if (value.length === 0) {
          callback(new Error('请输入反馈信息'))
        } else {
          callback()
        }
      }
      return {
        AddForm:{
          admin_id:'',
          id:'',
          reject_type:'3',
          reject_content:'',
        },
        rules: {
          reject_content: [{
            required: true,
            trigger: 'blur',
            validator: reject_content
          }],
        },
        data:'',
        tableData: [],
        tableData1: [],
        tableData2: [],
        loading: false,
        formInline: {
          id:'',
          name:'',
          statetime:'',
          endtime:'',
          pageNum:1,
          pageSize:10,
          type:'',
          reject_type:'',
        },
        pageSizes:[5, 10, 15, 20],
        pageTotal:0,
        //
        formInline1: {
          id:'',
          name:'',
          statetime:'',
          endtime:'',
          pageNum:1,
          pageSize:10,
          type:'',
          reject_type:'',
        },
        pageSizes1:[5, 10, 15, 20],
        pageTotal1:0,
        //
        formInline2: {
          id:'',
          name:'',
          statetime:'',
          endtime:'',
          pageNum:1,
          pageSize:10,
          type:'',
          reject_type:'',
        },
        pageSizes2:[5, 10, 15, 20],
        pageTotal2:0,
      }
    },

    filters: {
          formatDate: function (value) {
            /*返回总体日期*/
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? ('0' + MM) : MM;
            let d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            let h = date.getHours();
            h = h < 10 ? ('0' + h) : h;
            let m = date.getMinutes();
            m = m < 10 ? ('0' + m) : m;
            let s = date.getSeconds();
            s = s < 10 ? ('0' + s) : s;
            //return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
            /*返回判断日期*/
            let timestamp = (new Date()).valueOf();
            let time=timestamp-value;//时间差
            let minute = 1000*60;
            let hour = minute * 60;
            var day = hour * 24;
            let times="";//内容
            let min = time/minute;//分钟
            let hours = time/hour;//天数
            return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
          }
        },

    created() {
      //this.getData();
    },
    //页面开启时执行
    mounted(){
      this.chark();
      this.getData();
    },
    methods: {
      //进行判定
      chark(){
        this.$emit("parentHandle", 3)
      },
      //条件审核结果
      Addhandle(){
        this.$refs.AddForm.validate(valid => {
        if (valid) {
          this.AddForm.admin_id=this.$store.state.a_id;
          commonAPI('authentication_infor',this.AddForm).then(res => {
            let data = res.data;
            //console.log(res.data.rows);
            if(this.response.response(data)){
              this.AddForm.type='3';
              this.AddForm.reject_content='';
              this.getData();
              this.close();
              this.closehandle();
            }else{
              this.loading = false;
            }
          }).catch(error=>{
            this.loading = false;
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: error.message,
              position: 'bottom-right',
              type: 'error'
            });
            })
        }else{
          return false;
        }
        })
      },
      //图片转换数组
      transformation_data(img_url){
        let arr1=[];
        arr1.push(img_url);
        return arr1;
      },
      //打开办理界面
      openA(data){
        this.data=data;
        document.getElementById('Aut_information_auth').style.display='block';
        document.getElementById('zhedang').style.display='block';
      },
      close(){
        this.data="";
        document.getElementById('Aut_information_auth').style.display='none';
        document.getElementById('zhedang').style.display='none';
      },
      openhandle(data){
        //this.data=data;
        this.AddForm.id=data.id;
        this.AddForm.u_id=this.data.u_id;
        document.getElementById('handleForm_auth').style.display='block';
        document.getElementById('zhedang1').style.display='block';
      },
      closehandle(){
        this.AddForm.id="";
        this.AddForm.u_id="";
        document.getElementById('handleForm_auth').style.display='none';
        document.getElementById('zhedang1').style.display='none';
      },
      //重置查询
      resetting() {
        this.formInline.id = '';
        this.formInline.name = '';
        this.formInline.statetime = '';
        this.formInline.endtime = '';
        this.getData();
      },
      //
      //重置查询
      resetting1() {
        this.formInline1.id = '';
        this.formInline1.name = '';
        this.formInline1.statetime = '';
        this.formInline1.endtime = '';
        this.getData1();
      },
      //
      //重置查询
      resetting2() {
        this.formInline2.id = '';
        this.formInline2.name = '';
        this.formInline2.statetime = '';
        this.formInline2.endtime = '';
        this.getData2();
      },
      //查询
      getData() {
        this.loading = true,
        this.formInline.type="2";
        this.formInline.reject_type="1";
        commonAPI('queryAuthenticationList',this.formInline).then(res => {
          this.loading = false;
          this.tableData = res.data.data.rows;
          this.pageTotal=res.data.data.total;
          //console.log(res.data.rows);
          this.formInline.type="";
          this.formInline.reject_type="";
        })
      },
      onSubmit() {
        this.getData();
      },
      handleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.formInline.pageSize=val;
        this.formInline.pageNum=1;
        this.getData();
      },
      handleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.formInline.pageNum=val;
        this.getData();
      },
      //
      //查询成功的
      getData1() {
        this.loading = true,
        this.formInline1.type="3";
        this.formInline1.reject_type="2";
        commonAPI('queryAuthenticationList',this.formInline1).then(res => {
          this.loading = false;
          this.tableData1 = res.data.data.rows;
          this.pageTotal1=res.data.data.total;
          //console.log(res.data.rows);
          this.formInline1.type="";
          this.formInline1.reject_type="";
        })
      },
      onSubmit1() {
        this.getData();
      },
      handleSizeChange1(val) {
        //console.log(`每页 ${val} 条`);
        this.formInline1.pageSize=val;
        this.formInline1.pageNum=1;
        this.getData();
      },
      handleCurrentChange1(val) {
        //console.log(`当前页: ${val}`);
        this.formInline1.pageNum=val;
        this.getData1();
      },
      //
      //查询失败的
      getData2() {
        this.loading = true,
        this.formInline2.type="3";
        this.formInline2.reject_type="3";
        commonAPI('queryAuthenticationList',this.formInline2).then(res => {
          this.loading = false;
          this.tableData2 = res.data.data.rows;
          this.pageTotal2=res.data.data.total;
          //console.log(res.data.rows);
          this.formInline2.type="";
          this.formInline2.reject_type="";
        })
      },
      onSubmit2() {
        this.getData2();
      },
      handleSizeChange2(val) {
        //console.log(`每页 ${val} 条`);
        this.formInline2.pageSize=val;
        this.formInline2.pageNum=1;
        this.getData();
      },
      handleCurrentChange2(val) {
        //console.log(`当前页: ${val}`);
        this.formInline2.pageNum=val;
        this.getData2();
      },
    }
  }
</script>

<style scoped>
  .elInput,
  .btn {
    margin-top: 0px;
  }
  .el-main {
    padding: 5px 10px;
  }
  .elMain{
    height: 700px;
  }
  .el-table th {
    height: 45px;
    font-size: 16px;
    font-family: 微软雅黑;
    font-weight: 500;
    color: darkblue;
  }
  /**登录框架*/
  .logindiv{
    position: fixed;
    top: 25%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:2004;
    overflow: auto;
    text-align: center;
    display: none;
  }
  .loginForm{
    margin: 0 auto;
    width: 550px;
    background-color: #fff;
    -webkit-box-shadow: #333 0px 5px 5px;
    -moz-box-shadow: #333 0px 5px 5px;
    box-shadow: #333 0px 5px 5px;
  }
  .loginForm a{
    color: #fff;
  }
  .loginForm a:hover{
    color: #d6d6d6;
  }

  /**Orderinfor框架*/
  .Orderinfordiv{
    position: fixed;
    top: 13%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:2002;
    overflow: auto;
    display: none;
  }
  .OrderinforForm{
    margin: 0 auto;
    width: 900px;
    background-color: #fff;
    -webkit-box-shadow: #333 0px 5px 5px;
    -moz-box-shadow: #333 0px 5px 5px;
    box-shadow: #333 0px 5px 5px;
  }
  .OrderinforForm a{
    color: #fff;
  }
  .OrderinforForm a:hover{
    color: #d6d6d6;
  }
  .playlistbox_botton{
     width: 900px;margin: 0 auto;
     overflow: hidden;
     height: 633px;
     overflow-y: scroll;
   }
   /**滚动条样式*/
   .playlistbox_botton::-webkit-scrollbar{
     width: 5px;
   }
   .playlistbox_botton::-webkit-scrollbar-thumb{
     border-radius: 10px;
     -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
     background: #535353;
   }
   .playlistbox_botton::-webkit-scrollbar-thumb{
     -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
     border-radius: 10px;
     background: #EDEDED;
   }
   /**！Orderinfor框架*/
   td{padding: 13px 15px;font-size: 14px;}

</style>



// WEBPACK FOOTER //
// src/admin/views/authentication/Authentication.vue